import type { ListResponse } from '../../../common/types';
import { annotationToolApiV1, getAnnotationToolBasePath } from '../../../lib';
import { QueueDropdownResponse } from '../../workspace-common/types/responseTypes';
import { ANNOTATOR_QUEUE_TAG } from '../constants';
import type { AnnotationTaskResponse } from '../types/responseTypes';

export const annotatorQueueApiSlice = annotationToolApiV1
  .enhanceEndpoints({
    addTagTypes: [ANNOTATOR_QUEUE_TAG],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      getAnnotationEncounters: builder.query<
        ListResponse<AnnotationTaskResponse>,
        {
          projectId: string;
          batchId: string;
        }
      >({
        query: ({ projectId, batchId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = `/internal-message-gateway${basePath}`;

          const params: Record<string, string> = {};
          if (projectId) params['project_id'] = projectId;
          if (batchId) params['batch_id'] = batchId;

          return {
            url: `${tempPath}/work-queue/annotation-encounters`,
            method: 'GET',
            params,
          };
        },
        providesTags: [ANNOTATOR_QUEUE_TAG],
      }),
      getProjects: builder.query<ListResponse<QueueDropdownResponse>, void>({
        query: () => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/projects/annotator-projects`;
        },
        providesTags: [ANNOTATOR_QUEUE_TAG],
      }),
      getBatches: builder.query<ListResponse<QueueDropdownResponse>, { projectId: string }>({
        query: ({ projectId }) => {
          const basePath = getAnnotationToolBasePath();
          const tempPath = '/internal-message-gateway' + basePath;
          return `${tempPath}/projects/${projectId}/annotator-batches`;
        },
        providesTags: [ANNOTATOR_QUEUE_TAG],
      }),
    }),
  });

export const { useGetAnnotationEncountersQuery, useGetProjectsQuery, useGetBatchesQuery } =
  annotatorQueueApiSlice;
